<select (change)="changeShop()" [(ngModel)]="currencyService.shopNo" name="fm" id="fm" class="form-control">
  <option *ngFor="let shop of shopList; let i = index" [value]="shop.shopNo">{{shop.name}}</option>
</select>
